import { render, staticRenderFns } from "./SurveyCompleted.vue?vue&type=template&id=3e6cef06&"
import script from "./SurveyCompleted.vue?vue&type=script&lang=ts&"
export * from "./SurveyCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports